import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const ModalAlert = ({ setOpen, open }) => {
  const { membershipStatus } = useSelector((state) => state.membershipReducer);
  const { status } = useSelector((state) => state.userReducer);
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open ?? false}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      sx={{ zIndex: 9999 }}
    >
      <DialogTitle>Tú cuenta no está completa.</DialogTitle>
      <DialogContent>
        <Typography>
          {status === "inactive"
            ? "Verifica tu correo para disfrutar de los beneficios."
            : status === "pending"
              ? "Completa tu información y verifica tu número de teléfono, para disfrutar de los beneficios."
              : membershipStatus === "inactive" &&
                "Adquiere una membresía para disfrutar de todos los beneficios."}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
          onClick={handleClose}
        >
          Aceptar
        </Button>
        {status === "pending" && (
          <Button
            variant="outlined"
            color="#e7ef7d"
            onClick={() => navigate("/dashboard/profile")}
          >
            Completar
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
export default ModalAlert;
